import { Button, Box, Typography, Chip, useTheme } from '@mui/material';
import { useState } from 'react';
import ExoDialog from '../../exo/ExoDialog';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import useFetch from '../../../api/useFetch';
import { tokens } from '../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import { htmlToQuillDelta } from '../../exo/rich-text-editor/quillHtmlToDelta.ts';

export const BookingLinkStyle = ({ onInsert }) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const { apiData } = useFetch('booking-pages');

  function handleSelect(bookingPage) {
    const bookingUrl = `${window.location.origin}/book/${bookingPage.token}`;

    const html = [
      '<p><br></p>',
      `<p><strong>📅 ${bookingPage.name}</strong></p>`,
      `<p><span style="color: #888888;">${t('Duration')}: ${bookingPage.appointmentDuration} ${t('Minutes')}</span></p>`,
      `<p><a href="${bookingUrl}" target="_blank"><strong>➤ ${t('Book appointment now')}</strong></a></p>`,
      '<p><br></p>',
    ].join('');

    onInsert(htmlToQuillDelta(html));
    setOpen(false);
  }

  const activePages =
    apiData?.data?.filter((page) => page.isActive) || [];

  return (
    <>
      <Button
        className="grouped"
        onClick={() => setOpen(true)}
        sx={{ minWidth: '37px' }}
      >
        <div className="w-4 h-4 flex justify-center items-center">
          <CalendarMonthIcon />
        </div>
      </Button>
      <ExoDialog
        open={open}
        limitWidth
        onClose={() => setOpen(false)}
        title={t('Insert Booking Link')}
      >
        <Box className="flex flex-col gap-2 p-4">
          {activePages.length === 0 && (
            <Typography className="opacity-50 text-center py-4">
              {t('No active booking pages available.')}
            </Typography>
          )}
          {activePages.map((page) => (
            <Box
              key={page.id}
              className="flex items-center gap-3 p-3 rounded-lg cursor-pointer"
              onClick={() => handleSelect(page)}
              sx={{
                bgcolor: colors.bgInput,
                ':hover': {
                  bgcolor: colors.selected,
                },
              }}
            >
              <CalendarMonthIcon sx={{ color: colors.info }} />
              <Box className="flex-1">
                <Typography fontWeight={600}>{page.name}</Typography>
                <Typography variant="body2" className="opacity-50">
                  {page.appointmentDuration} {t('Minutes')}
                </Typography>
              </Box>
              <Chip
                label={t('Active')}
                color="success"
                size="small"
              />
            </Box>
          ))}
        </Box>
      </ExoDialog>
    </>
  );
};
